var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.81 0C38.5156 0 49.6201 11.2004 49.6201 25.0244C49.6201 38.8484 38.5156 50.0488 24.81 50.0488C11.1045 50.0488 -2.67029e-05 38.8484 -2.67029e-05 25.0244C-2.67029e-05 11.2004 11.1045 0 24.81 0ZM24.81 45.2054C35.8645 45.2054 44.8182 36.1744 44.8182 25.0244C44.8182 13.8744 35.8645 4.84344 24.81 4.84344C13.7556 4.84344 4.80192 13.8744 4.80192 25.0244C4.80192 36.1744 13.7556 45.2054 24.81 45.2054ZM18.6275 34.6709L27.121 28.4451C27.4311 28.213 27.6112 27.8498 27.6112 27.4663V10.8977C27.6112 10.2318 27.071 9.68687 26.4107 9.68687H23.2094C22.5491 9.68687 22.0089 10.2318 22.0089 10.8977V25.196L15.3262 30.0999C14.786 30.4935 14.6759 31.2502 15.0661 31.7951L16.9469 34.4086C17.337 34.9434 18.0873 35.0645 18.6275 34.6709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock_icon.066836c7e3189a600c0f88d1c09b5102.svg";
export { ForwardRef as ReactComponent };